import ManagerListContainer from './ManagerListContainer';
export default ManagerListContainer;
